export default __webpack_public_path__ + "static/media/ExperienceWorkingGirl.a458aff5.png";